import { useIdentify } from '@hungryroot/customer';
import { type PlanServicePlanComponents } from '@hungryroot/rest';
import { usePlanServiceCustomerPlansView } from './usePlanServiceCustomerPlansView';

export function getPricingServiceServingSize(
  planServiceData?: PlanServicePlanComponents
) {
  if (planServiceData === undefined) {
    return undefined;
  }

  // NOTE - Containers with the container_pricing_strategy of RECIPE_QUANTITY will be either lunch or dinner containers. Serving size of either of these two containers can be used where the UI needs plan serving size. This will change in the future, for example, when the breakfast container is added and this logic will need to be updated in discussion with BE and product at that time.
  const containerWithServingSize = planServiceData?.plan_components.find(
    (container) => container.container_pricing_strategy === 'RECIPE_QUANTITY'
  );

  return containerWithServingSize?.pricing_configurations.RECIPE_QUANTITY
    ?.serving_size;
}

export function usePlanServingSize() {
  const { customerData } = useIdentify();

  const { data: planServiceData } = usePlanServiceCustomerPlansView(
    {
      is_staged: 0,
    },
    { enabled: !!customerData?.id }
  );

  return getPricingServiceServingSize(planServiceData);
}

export function useCustomerServingSize() {
  const servingSize = usePlanServingSize();
  return servingSize;
}
